<template>
  <div>
    <label>Recipient / Sender</label>
    <v-select
      taggable
      placeholder="Choose One"
      @search="fetUserOptions"
      :value="contact"
      @input="userSelected"
      :options="userOptions"
      :create-option="
        (name) => ({
          name: name,
          code: '',
          phone: null,
          email: null,
          tax_id: null,
          address: null,
        })
      "
      label="name"
    >
      <template v-slot:option="option">
        <div>
          <span class="text-bold text-capitalize">{{ option.name }}</span
          ><br />
          <span v-if="option.email">{{ option.email }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: ["contact"],
  data() {
    return {
      userOptions: [],
    };
  },
  methods: {
    async fetUserOptions(keyword = null) {
      let res = await axios.get("accounting/user_lists", {
        params: { keyword },
      });
      this.userOptions = res.data;
    },
    userSelected(item) {
      if (!item) {
        let data = {};
        data["name"] = null;
        this.$emit("input", data);
      } else {
        this.$emit("input", item);
      }
    },
  },
  mounted() {
    this.fetUserOptions();
  },
};
</script>

<style scoped>
</style>
